import { IIdentity } from './common';

export enum TRiskLevel {
  Level1 = 1,
  Level2,
  Level3,
}

export interface IRiskLevel extends IIdentity {
  riskLevelId: TRiskLevel;
  description: string;
  longName: string;
  shortName: string;
}
